function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 120,
  height: 120,
  rx: 60,
  fill: "#6FA4FF",
  fillOpacity: 0.3
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.5591 60.0001V63.0589L47.5003 64.5884L57.4414 63.0589L58.9708 61.5295L57.4414 60.0001L47.5003 58.4707L37.5591 60.0001Z",
  fill: "#FF9100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.4416 60.0001L73.5004 58.4707L63.5592 60.0001L62.0298 61.5295L63.5592 63.0589L73.5004 64.5884L83.4416 63.0589C83.4416 61.9884 83.4416 61.0707 83.4416 60.0001Z",
  fill: "#FF7100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5591 63.0588V73.7647L46.7356 82.9412H57.4414L58.9708 73L57.4414 63.0588C56.3403 63.0588 38.6603 63.0588 37.5591 63.0588Z",
  fill: "#A44F3E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.4416 63.0588C82.3404 63.0588 64.6604 63.0588 63.5592 63.0588L62.0298 73L63.5592 82.9412H74.2651L83.4416 73.7647V63.0588Z",
  fill: "#883F2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.7356 82.9412C45.6242 82.9412 38.6807 82.9412 37.5591 82.9412C37.5591 81.8299 37.5591 74.8863 37.5591 73.7648C42.6265 73.7648 46.7356 77.8738 46.7356 82.9412Z",
  fill: "#883F2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.2646 82.9412H83.4411C83.4411 81.8299 83.4411 74.8863 83.4411 73.7648C78.3737 73.7648 74.2646 77.8738 74.2646 82.9412Z",
  fill: "#773124"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.4409 60.0001V82.9413H60.4997L62.0291 71.4707L60.4997 60.0001L58.9703 58.4707L57.4409 60.0001Z",
  fill: "#883F2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.5588 60.0001L62.0294 58.4707L60.5 60.0001V82.9413H63.5588C63.5588 81.3915 63.5588 61.5499 63.5588 60.0001Z",
  fill: "#773124"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.3242 37.0588V43.1765L52.8536 44.7059L54.383 43.1765C54.383 42.1059 54.383 41.1882 54.383 40.1177H60.5007L62.0301 38.5882L60.5007 37.0588C59.3893 37.0588 52.4458 37.0588 51.3242 37.0588Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.6177 43.1765L68.1471 44.7059L69.6765 43.1765C69.6765 42.4322 69.6765 37.8032 69.6765 37.0588C68.5651 37.0588 61.6216 37.0588 60.5 37.0588V40.1177H66.6177V41.6471V43.1765Z",
  fill: "#32393F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 43.1764V56.9411L47.5 58.4705L60.5 56.9411L62.0294 49.294L60.5 43.1764C59.7659 43.1764 35.2341 43.1764 34.5 43.1764Z",
  fill: "#BB5D4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5 43.1764V56.9411L73.5 58.4705L86.5 56.9411C86.5 55.8807 86.5 46.7654 86.5 43.1764C85.7659 43.1764 61.2341 43.1764 60.5 43.1764Z",
  fill: "#A44F3E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 56.9412V60H60.5L62.0294 58.4706L60.5 56.9412C59.7659 56.9412 35.2341 56.9412 34.5 56.9412Z",
  fill: "#A44F3E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.5 60C86.5 58.9294 86.5 58.0118 86.5 56.9412C85.7659 56.9412 61.2341 56.9412 60.5 56.9412V60H86.5Z",
  fill: "#883F2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.3232 60L48.2644 61.5294L45.2056 60C45.2056 58.4706 45.2056 56.9412 45.2056 55.4117H51.3232V60Z",
  fill: "#FFDA2D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.6758 60L72.7346 61.5294L75.7934 60C75.7934 58.4706 75.7934 56.9412 75.7934 55.4117C75.0491 55.4117 70.4201 55.4117 69.6758 55.4117V60Z",
  fill: "#FDBF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.3232 64.5882C50.5789 64.5882 45.9499 64.5882 45.2056 64.5882C45.2056 63.0588 45.2056 61.5294 45.2056 60H51.3232V64.5882Z",
  fill: "#FDBF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.6758 64.5882H75.7934C75.7934 63.0588 75.7934 61.5294 75.7934 60C75.0491 60 70.4201 60 69.6758 60V64.5882Z",
  fill: "#FF9100"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  fill: "white",
  transform: "translate(34.5 34)"
})));

function SvgBusiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.b0e0b267.svg";
export { ForwardRef as ReactComponent };